/*
  INSERT INTO _10rs (_dmn, _key, _fst, _icn, _pfx, _10r_31r1f, _10rt0010i, _10ra0010s, _10ra0020s, _10ra0030s, _who, _dtm, "createdAt", "updatedAt")
  VALUES (0, 1, 1, '1', 'Kanri User', 0, 90, 'kanri', 'kanri', 'kanri@mail.com', -1, '2000-01-01 00:00:00', '2000-01-01 00:00:00', '2000-01-01 00:00:00');
  INSERT INTO _10rs (_dmn, _key, _fst, _icn, _pfx, _10r_31r1f, _10rt0010i, _10ra0010s, _10ra0020s, _10ra0030s, _who, _dtm, "createdAt", "updatedAt")
  VALUES (1, 2, 2, '1', 'Staff User', 1, 20, 'staff', 'staff', 'staff@mail.com', -1, '2000-01-01 00:00:00', '2000-01-01 00:00:00', '2000-01-01 00:00:00');
  INSERT INTO _10rs (_dmn, _key, _fst, _icn, _pfx, _10r_31r1f, _10rt0010i, _10ra0010s, _10ra0020s, _10ra0030s, _who, _dtm, "createdAt", "updatedAt")
  VALUES (1, 3, 3, '1', 'Dantai User', 2, 10, 'dantai', 'dantai', 'dantai@mail.com', -1, '2000-01-01 00:00:00', '2000-01-01 00:00:00', '2000-01-01 00:00:00');
  UPDATE _10rs SET _vsn=1, _ltt=1;
  UPDATE _10rs SET _10ra1100s='rsv15843@gmail.com' where _fst=1;

  INSERT INTO _10rs (
    _dmn, _key, _vsn, _ltt, _fst, 
    _icn, _pfx, 
    _10r_31r1f, _10rt1100i, _10ra1100s, _10ra2100s,
    _who, _dtm, "createdAt", "updatedAt")
  VALUES (
    0, 16, 1, 1, 16, 
    '1', 'Kanri User', 
    0, 90, 'yko.bear.1975@gmail.com', '',
    -1, '2000-01-01 00:00:00', '2000-01-01 00:00:00', '2000-01-01 00:00:00'
  );

  INSERT INTO _101s (
    _dmn, _key, _fst, 
    _101_31r1f, _101_10r1k, 
    _101a1100s, _101a2100i,
    _who, _dtm, "createdAt", "updatedAt")
  VALUES (
    1, 2, 2,
    1, 11,
    '43214321', 0,
    -1, '2000-01-01 00:00:00', '2000-01-01 00:00:00', '2000-01-01 00:00:00'
  );

  INSERT INTO _10rs (
    _dmn, _key, _vsn, _ltt, _fst, 
    _icn, _pfx, 
    _10r_31r1f, _10rt1100i, _10ra1100s, _10ra2100s,
    _who, _dtm, "createdAt", "updatedAt")
  VALUES (
    0, 16, 1, 1, 16, 
    '2', 'Kanri', 
    0, 90, 'yko.bear.1975@gmail.com', '',
    -1, '2000-01-01 00:00:00', '2000-01-01 00:00:00', '2000-01-01 00:00:00'
  );

  INSERT INTO _10rs (
    _dmn, _key, _vsn, _ltt, _fst, 
    _icn, _pfx, 
    _10r_31r1f, _10rt1100i, _10ra1100s, _10ra2100s,
    _who, _dtm, "createdAt", "updatedAt")
  VALUES (
    3, 17, 1, 1, 17, 
    '61', 'Staff61a', 
    61, 20, '', 'staff1',
    -1, '2000-01-01 00:00:00', '2000-01-01 00:00:00', '2000-01-01 00:00:00'
  );

  INSERT INTO _101s (
    _dmn, _key, _fst, 
    _101_31r1f, _101_10r1k, 
    _101a1100s, _101a2100i,
    _who, _dtm, "createdAt", "updatedAt")
  VALUES (
    3, 3, 3,
    61, 17,
    '14231423D', 0,
    -1, '2000-01-01 00:00:00', '2000-01-01 00:00:00', '2000-01-01 00:00:00'
  );

  INSERT INTO _10rs (
    _dmn, _key, 
    _icn, _pfx, 
    _10r_31r1f, _10rt1100i, _10ra1100s, _10ra2100s,
    _who, _dtm, "createdAt", "updatedAt")
  VALUES (
    1, 22, 
    'staffN1', 'staffN1', 
    4, 20, '', 'staffN1',
    -1, '2000-01-01 00:00:00', '2000-01-01 00:00:00', '2000-01-01 00:00:00'
  );

  INSERT INTO _101s (
    _dmn, _key, _vsn, _ltt, _fst, 
    _101_31r1f, _101_10r1k, 
    _101a1100s, _101a2100i,
    _who, _dtm, "createdAt", "updatedAt")
  VALUES (
    1, 6, 1, 1, 6,
    4, 22,
    '43214321', 0,
    -1, '2000-01-01 00:00:00', '2000-01-01 00:00:00', '2000-01-01 00:00:00'
  );

  INSERT INTO _10rs (
    _dmn, _key, 
    _icn, 
    _10r_31r1f, _10rt1100i, _10ra1100s, _10ra2100s,
    _who, _dtm, "createdAt", "updatedAt")
  VALUES (
    1, 21, 
    '1_1', 
    1, 10, 'rsv15843@gmail.com', '',
    -1, '2000-01-01 00:00:00', '2000-01-01 00:00:00', '2000-01-01 00:00:00'
  );

  INSERT INTO _101s (
    _dmn, _key, 
    _101_31r1f, _101_10r1k, 
    _101a1100s, _101a2100i,
    _who, _dtm, "createdAt", "updatedAt")
  VALUES (
    1, 7,
    1, 21,
    '43214321', 0,
    -1, '2000-01-01 00:00:00', '2000-01-01 00:00:00', '2000-01-01 00:00:00'
  );

*/

export const _10z = {
  _10r: { // ユーザ情報 ユーニーク性をDBレベルで担保するため、履歴保持の対象外
    v0: {
      itlz: {
        _10r_31r1f: -1,
        _10rt1100i: -1,
        _10ra1100s: '',
        _10ra2100s: '',
      },
      unqs: [ // ユーザーが施設をまたぐため、_10r_31r1f は条件に含めない
        '_dmn',
        '_10rt1100i',
        '_icn',
      ],
      fldz: {
        _10r_31r1f: { // 所属組織 
          pfx: '',
        },
        _10rt1100i: { // 利用者区分
          pfx: '',
        },
        _10ra1100s: { // メールアドレス
          pfx: '',
        },
        _10ra2100s: { // ログインID
          pfx: '',
        },
      },
    },
  },

  _101: { // ログイン情報（パスワードの場合に使用）、_10r に準じ履歴対象外
    v0: {
      itlz: {
        _101_31r1f: -1,
        _101_10r1k: -1,
        _101a1100s: '',
        _101a2100i: 0,
      },
      unqs: [
        '_101_10r1k',
      ],
      fldz: {
        _101_31r1f: { // 所属組織 
          pfx: '',
        },
        _101_10r1k: { // ユーザ
          pfx: '',
        },
        _101a1100s: { // パスワード
          pfx: '',
        },
        _101a2100i: { // パスワード誤り回数
          pfx: '',
        },
      },
    },
  },

};
